import React from 'react'
import PropTypes from 'prop-types'
import WithLabel from '../WithLabel'
import Input from '../Input'

/**
 * The [Input](#Input) component with a label.
 */
const LabeledInput = ({ icon, label, rightLabel, color, ...domProps }) => (
  <WithLabel {...domProps} icon={icon} label={label} rightLabel={rightLabel} color={color}>
    {props => <Input {...props} />}
  </WithLabel>
)

LabeledInput.defaultProps = {
  color: 'light',
}

LabeledInput.propTypes = {
  ...Input.propTypes,
  /**
   * The icon to display.
   */
  icon: PropTypes.elementType,
  /**
   * An optional label to display alongside the icon.
   */
  label: PropTypes.node,
  /**
   * An optional label to display to the right.
   */
  rightLabel: PropTypes.node,
  /**
   * The color of the icon holder.
   */
  color: PropTypes.string,
}

export default LabeledInput
